module.exports = __webpack_public_path__ + "img/modulo_Reward.6bd68bb.svg";